module.exports = __webpack_public_path__ + "img/event2-slide-img.76cc8ca5.svg";